import { Edit, SimpleForm, useRedirect, useNotify, useRefresh } from "react-admin";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";
import { ExamCategories, REGULAR } from "utils/constants";
import { candidateRequests } from "api/candidateApi";
import dataProvider from "server/dataProvider";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditRegularCampaign = () => {
  const redirect = useRedirect();
  const notify = useNotify();
  const refresh = useRefresh();

  const campaignSave = async data => {
    if (data.rooms && data.rooms.length > 0) {
      data.rooms = data.rooms.map((room, roomIndex) => ({
        ...room,
        priority: ++roomIndex,
      }));
    }

    if (data.exams && data.exams.length > 0) {
      data.exams = data.exams.map(exam => {
        if (exam.examCategoryId === ExamCategories.DocumentBased) {
          exam.examDays = [];
        }
        exam.examDays = exam.examDays.map(examDay => {
          const examOnlyDate = examDay.examStartTimestamp?.split("T")[0];
          if (examDay.timeSlots && examDay.timeSlots.length > 0) {
            examDay.timeSlots = examDay.timeSlots.map(timeSlot => {
              timeSlot.startTime = timeSlot.startTime ? examOnlyDate + "T" + timeSlot.startTime.split("T")[1] : null;
              timeSlot.endTime = timeSlot.endTime ? examOnlyDate + "T" + timeSlot.endTime.split("T")[1] : null;
              timeSlot.breakHourStart = timeSlot.breakHourStart
                ? examOnlyDate + "T" + timeSlot.breakHourStart.split("T")[1]
                : null;
              timeSlot.breakHourEnd = timeSlot.breakHourEnd
                ? examOnlyDate + "T" + timeSlot.breakHourEnd.split("T")[1]
                : null;
              if (timeSlot.rooms && timeSlot.rooms.length > 0 && timeSlot.isRoomsChanges) {
                timeSlot.rooms = timeSlot.rooms.map((room, roomIndex) => ({
                  ...room,
                  priority: ++roomIndex,
                }));
              }
              return timeSlot;
            });
          }
          return examDay;
        });
        return exam;
      });
    }

    try {
      await dataProvider.update(candidateRequests.campaignByType(REGULAR), { id: data.id, data: data });
      notify("Успешно редактиране", { type: "success" });
      redirect("list", candidateRequests.campaignByType(REGULAR));
      refresh();
    } catch (error) {
      notify(`Error: ${error.message || "Грешка при редактиране"}`, { type: "error" });
    }
  };

  return (
    <Edit
      title="Редакция на редовна кампания"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm
        toolbar={<InactiveDeleteOptionEditToolbar />}
        onSubmit={campaignSave}
      >
        <SaveForm isEdit />
      </SimpleForm>
    </Edit>
  );
};
export default EditRegularCampaign;
